export const ADSENSE_PUBLISHER_ID = "ca-pub-6558750663831772";

export const ADSENSE_SLOTS = Object.freeze({
  header: process.env.REACT_APP_ADSENSE_HEADER_SLOT?.trim() || "",
  discover: process.env.REACT_APP_ADSENSE_DISCOVER_SLOT?.trim() || "",
  chat: process.env.REACT_APP_ADSENSE_CHAT_SLOT?.trim() || "",
});

export function isValidPublisherId(value) {
  return /^ca-pub-\d{16}$/.test(value || "");
}

export function isValidAdSlot(value) {
  return /^\d{5,20}$/.test(value || "") && !/^0+$/.test(value);
}
